import { TransactionType } from './transaction-type';
import { Transaction } from './transaction';

/**
 * Transaction model
 */
export class ConsolidatedTransaction {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public id: number,
    public totalPoints: number,
    public transactionType: TransactionType,
    public generationDate: Date,
    public expirationDate: Date | null,
    public userName: string,
    public transactionId: number,
    public note: string,
    public transactions: Transaction[]
  ) {}
}
